import React, { ForwardedRef } from 'react';
import classNames from 'classnames';
import { ChevronDownIcon } from '@fiverr-private/icons';
import { usePopoverContext } from '@fiverr-private/popover';
import { SELECT_ROLE, SELECT_SIZES } from '../constants';
import type { SelectProps } from '../types';

import styles from './index.module.scss';

const Trigger = React.forwardRef(
  (
    { placeholder, name, isSuccess, isError, disabled, size, hideChevron, children, fullWidth }: Partial<SelectProps>,
    ref: ForwardedRef<HTMLDivElement>
  ) => {
    const showPlaceHolder = !children && placeholder;
    const { open } = usePopoverContext();

    return (
      <div
        title={name}
        className={classNames(styles.trigger, {
          [styles.open]: open && !disabled,
          [styles.success]: isSuccess,
          [styles.error]: isError,
          [styles.disabled]: disabled,
          [styles.fullWidth]: fullWidth,
        })}
        tabIndex={disabled ? -1 : 0}
        ref={ref}
      >
        <label
          role={SELECT_ROLE}
          className={classNames({
            [styles.large]: size === SELECT_SIZES.lg,
            [styles.fullWidth]: fullWidth,
          })}
        >
          <p
            className={classNames({
              [styles.withPlaceholder]: showPlaceHolder,
              [styles.hideChevron]: hideChevron,
            })}
          >
            {showPlaceHolder ? placeholder : children}
          </p>
          {!hideChevron && (
            <span>
              <ChevronDownIcon color="currentColor" size={12} />
            </span>
          )}
        </label>
      </div>
    );
  }
);

Trigger.displayName = 'Trigger';

export default Trigger;
